import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Player, TrackType } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { LocalStorageKeys } from '../../shared/LocalStorageKeys';
import { getTextTrackList } from '../../shared/utils/PlaybackUtils';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
export interface Track {
  type: TrackType;
  language: string;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-player-subtitles',
  templateUrl: './player-subtitles.component.html',
  styleUrls: ['./player-subtitles.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlayerSubtitlesComponent implements OnInit {
  @ViewChild('formatSize') formatText: ElementRef;
  @Output() closeDialog = new EventEmitter<void>();
  textTrackList: Track[] = [];

  constructor(
    private localStorage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      currentResource: ResourceVm;
      player: Player;
    },
    private navService: NavigationLibraryService
  ) {}

  ngOnInit(): void {
    if (this.data.player) {
      this.textTrackList = getTextTrackList(this.data.player);
    }
  }

  selectTextTrack(textTrack: Track): void {
    if (!textTrack) {
      textTrack = this.textTrackList[0];
    }
    this.localStorage.setItem(LocalStorageKeys.SUBTITLES_LANGUAGE, textTrack.language);
    if (textTrack.language === 'off') {
      this.data.player.selectTrack();
      this.localStorage.setItem(LocalStorageKeys.SUBTITLES_ENABLED, 'false');
    } else {
      this.data.player.selectTrack(textTrack);
      this.localStorage.setItem(LocalStorageKeys.SUBTITLES_ENABLED, 'true');
    }
    this.textTrackList.forEach((textTrackLt) => (textTrackLt.active = textTrack.language === textTrackLt.language ? true : false));
  }

  /**
   * Go to audio container at the left side
   */
  goToAudio(): void {
    this.navService.focusContainer('audio-vcontainer', false, 0);
    this.navService.setIndexContainer('audio-vcontainer', 0);
  }

  /**
   * Handle mouse enter in div to magic remote
   *
   * @param event
   * @param index
   */
  mouseEnter(event: MouseEvent, index: number): void {
    this.navService.focusElement(event.target as HTMLElement, 0, index);
  }

  /**
   * Handle close button event
   */
  close(): void {
    this.closeDialog.emit();
  }
}
